import { atom } from 'recoil';

import { iaRa } from 'lib/helpers/utility';
import { sessionPersistEffect } from 'lib/helpers/sessionPersistedAtom';

const DOCK_STORAGE_KEY = 'myriad:dock';

// Persist only the serializable descriptor — never renderer refs or tenant props.
const sanitize = (value) => ({
  items: iaRa(value?.items)
    .filter((it) => it && typeof it.id === 'string' && typeof it.kind === 'string')
    .map(({ id, kind, side, minimized }) => ({ id, kind, side, minimized }))
});

// Registry of docked widgets (`kind` maps to a renderer in ./constants), persisted to
// sessionStorage so a reload re-opens the same cards.
export const dockState = atom({
  key: 'dockState',
  default: { items: [] },
  effects: [sessionPersistEffect({ storageKey: DOCK_STORAGE_KEY, sanitize })]
});
